<template>
  <div>
    <mobile-modal
      v-if="$vuetify.breakpoint.xsOnly"
      :value="value"
      :type="type"
      :size="size"
      :title="title"
      :sub-title="subTitle"
      :primary-text="primaryText"
      :primary-text-case="primaryTextCase"
      :secondary-text="secondaryText"
      :warning-text="warningText"
      :warning-icon="warningIcon"
      :warning-button="warningButton"
      :disabled="disabled"
      :loading="loading"
      :icon="icon"
      :data-cy="dataCy"
      :content-class="contentClass"
      :show-back-button="showBackButton"
      :full-size-header-on-mobile="fullSizeHeaderOnMobile"
      :sn-input-props_pendo="snInputProps_pendo"
      :transition="transition"
      @back="onBack"
      @submit="onSubmit"
      @close="onClose"
      @input="$emit('input', $event)"
    >
      <slot />
    </mobile-modal>

    <web-modal
      v-else
      :value="value"
      :type="type"
      :size="size"
      :button-size="buttonSize"
      :title="title"
      :sub-title="subTitle"
      :persistent="persistent"
      :primary-text="primaryText"
      :primary-text-case="primaryTextCase"
      :secondary-text="secondaryText"
      :warning-text="warningText"
      :warning-icon="warningIcon"
      :warning-button="warningButton"
      :disabled="disabled"
      :loading="loading"
      :icon="icon"
      :secondary-icon="secondaryIcon"
      :data-cy="dataCy"
      :content-class="contentClass"
      :show-back-button="showBackButton"
      :sn-input-props_identifier="snInputProps_identifier"
      :sn-input-props_pendo="snInputProps_pendo"
      :transition="transition"
      :keydown-submit="keydownSubmit"
      @back="onBack"
      @submit="onSubmit"
      @secondarySubmit="onSecondarySubmit"
      @close="onClose"
      @input="$emit('input', $event)"
    >
      <slot />
      <template #table>
        <slot name="table" />
      </template>
      <template #footer>
        <slot name="footer" />
      </template>
      <template #preFooter>
        <slot name="preFooter" />
      </template>
    </web-modal>
  </div>
</template>

<script>
import MobileModal from './mobileModal.vue'
import WebModal from './webModal.vue'
import SnInputProps from '../props/SnInputProps'
import { cypressMixin } from '../mixins/cypressMixin'

export default {
  name: 'SnModal',
  components: {
    MobileModal,
    WebModal
  },
  mixins: [cypressMixin],
  props: {
    ...SnInputProps,
    value: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      default: 'confirmation',
      validator (type) {
        return ['confirmation', 'decision', 'dismiss'].includes(type)
      }
    },
    size: {
      type: String,
      default: 'standard',
      validator (size) {
        return ['standard', 'large', 'fullscreen'].includes(size)
      }
    },
    buttonSize: {
      type: String,
      default: 'standard',
      validator (buttonSize) {
        return ['small', 'standard', 'large', 'x-large', 'full-width'].includes(buttonSize)
      }
    },
    title: {
      type: String,
      default: 'Modal'
    },
    subTitle: {
      type: String,
      default: ''
    },
    persistent: {
      type: Boolean,
      default: false
    },
    primaryText: {
      type: String,
      default: 'Okay'
    },
    primaryTextCase: {
      type: String,
      default: 'sentence',
      required: false,
      validator (primaryTextCase) {
        return ['uppercase', 'title', 'sentence', ''].includes(primaryTextCase)
      }
    },
    secondaryText: {
      type: String,
      default: 'Cancel'
    },
    warningText: {
      type: String,
      default: ''
    },
    warningIcon: {
      type: String,
      default: ''
    },
    warningButton: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    secondaryIcon: {
      type: String,
      default: ''
    },
    contentClass: {
      type: String,
      default: ''
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    // Fullsize header on mobile allows a subtitle, and back button.
    // The Flow is changed from vertical to horizontal
    fullSizeHeaderOnMobile: {
      type: Boolean,
      default: false
    },
    transition: {
      type: String,
      default: 'dialog-transition',
      required: false
    },
    keydownSubmit: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  methods: {
    onSubmit () {
      this.$emit('submit')
    },

    onSecondarySubmit () {
      this.$emit('secondarySubmit')
    },

    onClose () {
      this.$emit('input', false)
    },

    onBack () {
      this.$emit('back')
    }
  }
}
</script>
